/**
 * Constants related to cash management movement types.
 */
export enum CASH_MOVEMENT_TYPES {
  CLOSING_CASH_FLOAT = 'Closing float',
  OPENING_CASH_FLOAT = 'Opening float',

  CASH_IN = 'Cash in',
  CASH_OUT = 'Cash out',

  PETTY_CASH_IN = 'Petty cash in',
  PETTY_CASH_OUT = 'Petty cash out',

  FLOAT_ADJUSTMENT = 'Float adjustment',
  TILL_DISCREPANCY = 'Till discrepancy',
}

export const CASH_MOVEMENTS = {
  add: [CASH_MOVEMENT_TYPES.CASH_IN, CASH_MOVEMENT_TYPES.PETTY_CASH_IN],
  remove: [CASH_MOVEMENT_TYPES.CASH_OUT, CASH_MOVEMENT_TYPES.PETTY_CASH_OUT],
}
